import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=50152d60&"
import script from "./ModuleEdit.vue?vue&type=script&lang=ts&"
export * from "./ModuleEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50152d60')) {
      api.createRecord('50152d60', component.options)
    } else {
      api.reload('50152d60', component.options)
    }
    module.hot.accept("./ModuleEdit.vue?vue&type=template&id=50152d60&", function () {
      api.rerender('50152d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ModuleEdit.vue"
export default component.exports